module.exports = __webpack_public_path__ + "static/media/JAI 04.6ff204a9.jpg";